import { borderColor } from "@mui/system";
import { Color, ColorSAP, FONT_FAMILY } from "../../ontego-ui";
import { styled } from '@mui/material';

const Styled = {};

Styled.Input = styled("div")(() => ({
    position: "absolute",
    opacity: 0,
    cursor: "pointer",
    height: 0,
    width: 0,
}));

Styled.Label = styled("div")(({ checked, type }) => ({
    display: "block",
    position: "relative",
    paddingLeft: "30px",
    lineHeight: "16px",
    cursor: "pointer",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
    fontSize: "14px",
    fontWeight: 400,

    "&::before": {
        boxSizing: "border-box",
        position: "absolute",
        content: "''",
        top: 0,
        left: 0,
        height: 20,
        width: 20,
        borderRadius: "50%",
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: ColorSAP.primary[checked ? 70 : 40],
    },
    // "&:hover": {
    //     fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR
    // },
    "&::after": {
        position: "absolute",
        content: "''",
        top: 4,
        left: 4,
        width: 12,
        height: 12,
        borderRadius: "50%",
        display: checked ? "block" : "none",
        backgroundColor: ColorSAP.primary[70],
    },
    "&:hover::before": {
        backgroundColor: ColorSAP.primary[20],
    },
    ...(!checked && {
        fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
        "&::after": {
            display: "none"
        },
        "&$disabled::before": {
            backgroundColor: "transparent"
        }
    }),
    ...(checked && {
        fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM,
        fontWeight: 500,
    }),
    "&$disabled": {
        fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
        color: Color.neutral[500],
        "&::before": {
            backgroundColor: Color.neutral[300],
            borderColor: Color.neutral[400]
        },
        "&:hover::before": {
            backgroundColor: Color.neutral[300],
            borderColor: Color.neutral[400]
        },
        "&::after": {
            backgroundColor: Color.neutral[500]
        }
    }
}));

Styled.n900 = styled("div")(() => ({
    color: ColorSAP.neutral[100],
    "&::before": {
        borderColor: ColorSAP.neutral[100],
    },
    "&:hover::before": {
        backgroundColor: ColorSAP.neutral[20],
        opacity: 0.5,
        borderColor: ColorSAP.neutral[100],
    },
    "&::after": {
        backgroundColor: ColorSAP.primary[70],
    }
}));

Styled.n000 = styled("div")(() => ({
    color: Color.neutral[0],
    "&::before": {
        borderColor: Color.neutral[0]
    },
    "&:hover::before": {
        backgroundColor: Color.neutral[300],
        borderColor: Color.neutral[300]
    },
    "&::after": {
        backgroundColor: Color.neutral[100]
    }
}));

Styled.disabled = styled("div")(() => ({}));

export default Styled;